var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 3.65625H17.125C17.4375 3.65625 17.75 3.38281 17.75 3.03125V1.46875C17.75 1.15625 17.4375 0.84375 17.125 0.84375H0.875C0.523438 0.84375 0.25 1.15625 0.25 1.46875V3.03125C0.25 3.38281 0.523438 3.65625 0.875 3.65625ZM0.875 9.90625H17.125C17.4375 9.90625 17.75 9.63281 17.75 9.28125V7.71875C17.75 7.40625 17.4375 7.09375 17.125 7.09375H0.875C0.523438 7.09375 0.25 7.40625 0.25 7.71875V9.28125C0.25 9.63281 0.523438 9.90625 0.875 9.90625ZM0.875 16.1562H17.125C17.4375 16.1562 17.75 15.8828 17.75 15.5312V13.9688C17.75 13.6562 17.4375 13.3438 17.125 13.3438H0.875C0.523438 13.3438 0.25 13.6562 0.25 13.9688V15.5312C0.25 15.8828 0.523438 16.1562 0.875 16.1562Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobile_menu.c2fbfd98ba16805a04faba08796213aa.svg";
export { ForwardRef as ReactComponent };